'use client'

import { sendGTMEvent } from '@next/third-parties/google'
import { useEffect, useRef } from 'react'
import { buildGA4EventModel } from '@/components/@analitycs/push-ecommerce-event'

export interface ViewContentEventProps {
  id: string
  name: string
  price: number
  currency?: string
}

export function ViewContentEvent({
  id,
  name,
  price,
  currency = 'BRL',
}: ViewContentEventProps) {
  const hasTrackedRef = useRef(false)

  useEffect(() => {
    if (hasTrackedRef.current) {
      return
    }
    hasTrackedRef.current = true

    ;(async () => {
      const eventModel = await buildGA4EventModel({
        currency,
        value: price,
        items: [{ id, name, price, quantity: 1 }],
      })

      sendGTMEvent({ ecommerce: null })
      sendGTMEvent({
        event: 'view_item',
        eventModel,
        ecommerce: eventModel,
        ...(eventModel.user_data && { user_data: eventModel.user_data }),
      })
    })()
  }, [id, name, price, currency])

  return null
}
